import { stringifyText } from 'app/shared/utils';

export interface ProgressState {
    error: boolean;
    errorMessage: string | undefined;
    running: boolean;
    done: boolean;
}

export const getInitialProgressState = (): ProgressState => {
    return { done: false, error: false, errorMessage: undefined, running: false };
};

export const done = (): ProgressState => ({
    done: true,
    error: false,
    errorMessage: undefined,
    running: false,
});
export const running = (): ProgressState => ({
    running: true,
    done: false,
    error: false,
    errorMessage: undefined,
});

/**
 * Error message may be returned as object/undefined/empty string in runtime
 */
export const error = (errorMessage?: string): ProgressState => {
    const msg = stringifyText(errorMessage);
    return {
        error: true,
        errorMessage: msg ? msg : 'Unknown error occurred',
        done: false,
        running: false,
    };
};
